import { httpV1 as http } from '../api';

export async function simulationValues(params) {
  return http
    .get('/cgv/simulation', { params })
    .then(({ data }) => data);
}

export async function getRates(params) {
  return http
    .get('/cgv/rates', { params })
    .then(({ data }) => data);
}

export async function getWaitList(params) {
  return http
    .get('/cgv/wait-list', { params })
    .then(({ data }) => data);
}

export async function postWaitList(params) {
  return http
    .post('/cgv/wait-list', { ...params })
    .then(({ data }) => data);
}

export async function deleteWaitList(data) {
  return http
    .delete('/cgv/wait-list/', { data })
    .then(({ data }) => data);
}

export async function saveProposal(params) {
  return http
    .post('/cgv/save-proposal', { ...params })
    .then(({ data }) => data);
}

export async function getProposalById(proposal_id) {
  return http
    .get(`/cgv/get-proposal?proposal_id=${proposal_id}`)
    .then(({ data }) => data);
}

export async function getInstallmentsByProposalId(proposal_id) {
  return http
    .get(`/cgv/list-installments?proposal_id=${proposal_id}`)
    .then(({ data }) => data);
}

export async function getSimulationDetailByProposalId(proposal_id) {
  return http
    .get(`/cgv/simulation-detail?proposal_id=${proposal_id}`)
    .then(({ data }) => data);
}

export async function creditOperation(params) {
  return http
    .post('/cgv/credit-operation', { params })
    .then(({ data }) => data);
}

export async function getFormalizationToken(params) {
  return http
    .get('/cgv/formalization', { params })
    .then(({ data }) => data);
}

export async function getCCBDetails(params) {
  return http
    .get('/cgv/ccb-detail', { params })
    .then(({ data }) => data);
}

export async function validateClientEligibility(params) {
  return http
    .get('/cgv/document-eligibility', { params })
    .then(({ data }) => data);
}
